// POC: Strongly inspired on https://every-layout.dev/layouts/stack/

export default {
  functional: true,
  props: {
    gap: {
      type: String,
      default: '1.5rem',
    },
    splitAfter: {
      type: Number,
      required: false,
    },
    justifyContent: {
      type: String,
      default: 'flex-start',
      validator: (value) =>
        ['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'].includes(value),
    },
    alignItems: {
      type: String,
      default: 'stretch',
      validator: (value) => ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'].includes(value),
    },
  },
  render(h, { props, slots, data }) {
    const children = slots().default || [];

    return h(
      'div',
      {
        ...data,
        class: ['stack'],
        style: {
          gap: props.gap,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: props.justifyContent,
          alignItems: props.alignItems,
        },
      },
      children.flatMap((child, index) => {
        const elements = [child];

        // Handle splitAfter to add auto margin for spacing between groups
        if (props.splitAfter !== undefined && index === props.splitAfter) {
          elements.push(h('div', { style: { marginBlockStart: 'auto' } }));
        }

        // Apply margin-block-end: auto to the specified child for proper splitting
        if (props.splitAfter !== undefined && index === props.splitAfter) {
          child.data = child.data || {};
          child.data.style = { ...child.data.style, marginBlockEnd: 'auto' };
        }

        return elements;
      }),
    );
  },
};
